import { Typography } from '@euler/app/components/typography';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { Center } from '@euler/components/Center';
import { getDefectiveLevelText } from '@euler/functions/getDefectiveLevel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { DefectiveLevel, DefectiveLevelColorMap } from '@euler/model';
import { memo } from 'react';
import { StyleProp, TextStyle, ViewStyle } from 'react-native';

export const DefectiveBadge = memo(
  ({
    defectiveLevel,
    colorMap,
    style,
    textStyle,
  }: {
    defectiveLevel: DefectiveLevel;
    colorMap: DefectiveLevelColorMap;
    style?: StyleProp<ViewStyle>;
    textStyle?: StyleProp<TextStyle>;
  }) => {
    const theme = usePresentationTheme();
    const { rpx } = useResponsiveContext();
    return (
      <Center
        css={`
          height: ${rpx(42)}px;
          background-color: ${colorMap[defectiveLevel]};
          border-top-left-radius: ${rpx(42) / 2}px;
          border-bottom-left-radius: ${rpx(42) / 2}px;
          padding-left: ${rpx(21)}px;
          padding-right: ${rpx(19)}px;
        `}
        style={style}
      >
        <Typography.Label
          regular
          size={rpx(24)}
          color={theme.task.defectiveBadge.textColor}
          css={`
            text-align: center;
          `}
          style={textStyle}
        >
          {getDefectiveLevelText(defectiveLevel)}
        </Typography.Label>
      </Center>
    );
  },
);
